import { ArrowRight } from "lucide-react";
import { AREAS } from "@/content";
import { SITE } from "@/constants/testIds";
import { Reveal, SectionHead } from "./Reveal";

const num = (i) => String(i + 1).padStart(2, "0");

const AreaCard = ({ a, i }) => (
  <Reveal delay={(i % 2) * 120} className="h-full">
    <article
      id={`area-${a.key}`}
      data-testid={SITE.areaCard(a.key)}
      className="group h-full flex flex-col rounded-3xl bg-white border border-navy-100 p-7 md:p-10 transition-[box-shadow,transform] duration-300 hover:-translate-y-1 hover:shadow-[0_24px_48px_rgba(0,43,74,0.10)]"
    >
      <div className="flex items-center justify-between">
        <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-navy-900 text-white transition-colors duration-300 group-hover:bg-bronze">
          <a.icon className="h-5 w-5" strokeWidth={1.6} />
        </span>
        <span className="text-xs font-bold tabular-nums tracking-[0.2em] text-bronze-600">{num(i)}</span>
      </div>
      <h3 className="mt-7 text-2xl md:text-[1.65rem] font-bold leading-tight tracking-tight text-navy-900">{a.title}</h3>
      <p className="mt-4 text-[15px] md:text-base leading-relaxed text-navy-500">{a.intro}</p>
      <ul className="mt-7 flex flex-col gap-2.5 flex-1">
        {a.items.map((it) => (
          <li key={it} className="flex gap-3 rounded-xl bg-navy-50 px-4 py-3 text-[14.5px] leading-snug text-navy-900">
            <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-bronze" />
            {it}
          </li>
        ))}
      </ul>
      <a
        href="#prenota"
        data-testid={`area-cta-${a.key}`}
        className="mt-8 inline-flex items-center gap-2 self-start text-sm font-semibold text-navy-900 hover:text-bronze-600 transition-colors"
      >
        Parliamone <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
      </a>
    </article>
  </Reveal>
);

export const AreasExplorer = () => (
  <section id="aree" className="section-pad bg-navy-50">
    <div className="container-x">
      <SectionHead
        index="01"
        eyebrow="Aree di attività"
        title="Cosa facciamo, in sei blocchi."
        intro="Dal rapporto di lavoro alla vita della società, dal recupero crediti alla famiglia: un unico referente per ogni questione."
      />
      <div className="grid md:grid-cols-2 gap-6">
        {AREAS.map((a, i) => <AreaCard key={a.key} a={a} i={i} />)}
      </div>
    </div>
  </section>
);
